/* eslint-disable no-param-reassign */
export default (state, { payload: { solutionInstanceId } }) => {
  state.trayInstances = state.trayInstances.filter((instance) => instance.id !== solutionInstanceId);
};
